(function () {
	let stickyClone = null;
	let lastScrollY = window.scrollY;
	let scrollingUp = false;

	let headerVisible = true;
	let intersectionObserver = null;

	function getHeader() {
		const sticky = document.querySelector(
			".has-sticky-header header.wp-block-template-part .sticky-header",
		);

		return (
			sticky ||
			document.querySelector(
				".has-sticky-header header.wp-block-template-part",
			)
		);
	}

	function removeStickyClone() {
		if (stickyClone && stickyClone.parentNode) {
			stickyClone.parentNode.removeChild(stickyClone);
			stickyClone = null;
		}
	}

	function createStickyClone(header) {
		removeStickyClone();

		if (!header) return;

		stickyClone = header.cloneNode(true);

		// If the clone is not a header.wp-block-template-part, wrap it
		if (
			!(
				stickyClone.tagName === "HEADER" &&
				stickyClone.classList.contains("wp-block-template-part")
			)
		) {
			const wrapper = document.createElement("header");
			wrapper.classList.add("wp-block-template-part");
			wrapper.appendChild(stickyClone);
			stickyClone = wrapper;
		}

		stickyClone.classList.add("sticky-clone");
		stickyClone.classList.add("sticky-clone--hidden");
		stickyClone.setAttribute("aria-hidden", "true");

		// Make all focusable elements unfocusable in the clone

		stickyClone
			.querySelectorAll("a, button, input, textarea, select, [tabindex]")
			.forEach((el) => {
				// Store original tabindex

				if (el.hasAttribute("tabindex")) {
					el.setAttribute(
						"data-original-tabindex",
						el.getAttribute("tabindex"),
					);
				}
				el.setAttribute("tabindex", "-1");

				// Store and set disabled

				if (
					el.tagName === "BUTTON" ||
					el.tagName === "INPUT" ||
					el.tagName === "SELECT" ||
					el.tagName === "TEXTAREA"
				) {
					if (el.hasAttribute("disabled")) {
						el.setAttribute("data-original-disabled", "true");
					}
					el.setAttribute("disabled", "true");
				}
			});

		// Remove IDs to avoid duplicates

		if (stickyClone.id) stickyClone.removeAttribute("id");

		stickyClone
			.querySelectorAll("[id]")
			.forEach((el) => el.removeAttribute("id"));

		document.body.appendChild(stickyClone);
	}

	function showStickyClone() {
		if (stickyClone) {
			stickyClone.classList.remove("sticky-clone--hidden");
			stickyClone.classList.add("sticky-clone--visible");

			// Restore original tabindex and disabled states

			stickyClone
				.querySelectorAll(
					"a, button, input, textarea, select, [tabindex]",
				)
				.forEach((el) => {
					// Restore tabindex

					if (el.hasAttribute("data-original-tabindex")) {
						el.setAttribute(
							"tabindex",
							el.getAttribute("data-original-tabindex"),
						);
						el.removeAttribute("data-original-tabindex");
					} else {
						el.removeAttribute("tabindex");
					}

					// Restore disabled

					if (
						el.tagName === "BUTTON" ||
						el.tagName === "INPUT" ||
						el.tagName === "SELECT" ||
						el.tagName === "TEXTAREA"
					) {
						if (el.hasAttribute("data-original-disabled")) {
							el.setAttribute("disabled", "true");
							el.removeAttribute("data-original-disabled");
						} else {
							el.removeAttribute("disabled");
						}
					}
				});
		}
	}

	function hideStickyClone() {
		if (stickyClone) {
			stickyClone.classList.remove("sticky-clone--visible");
			stickyClone.classList.add("sticky-clone--hidden");
		}
	}

	function updateStickyHeader(forceRecreate = false) {
		const header = getHeader();

		observeHeaderVisibility(header);

		if (!header) {
			removeStickyClone();

			return;
		}

		if (forceRecreate || !stickyClone) {
			createStickyClone(header);
		}
	}

	function isHeaderCovered() {
		const header = getHeader();

		if (!header) return false;

		const rect = header.getBoundingClientRect();

		return rect.bottom <= 0;
	}

	function shouldShowSticky() {
		const header = getHeader();

		if (!header) return false;

		const rect = header.getBoundingClientRect();
		const currentScrollY = window.scrollY;
		const windowHeight = window.innerHeight;
		const documentHeight = document.documentElement.scrollHeight;
		const atBottom = windowHeight + currentScrollY >= documentHeight - 2;

		scrollingUp = currentScrollY < lastScrollY;
		lastScrollY = currentScrollY;

		return currentScrollY > 0 && (atBottom || scrollingUp) && rect.top < 0;
	}

	function onScrollOrResize() {
		const atTop = window.scrollY === 0;
		const header = getHeader();
		const rect = header ? header.getBoundingClientRect() : { top: 0 };

		if (stickyClone) {
			if (rect.top >= 0) {
				stickyClone.classList.add("sticky-clone--instant-hide");
			} else {
				stickyClone.classList.remove("sticky-clone--instant-hide");
			}

			if (atTop) {
				stickyClone.classList.add("sticky-clone--at-top");
			} else {
				stickyClone.classList.remove("sticky-clone--at-top");
			}
		}
		if (shouldShowSticky() && !headerVisible) {
			showStickyClone();
		} else {
			hideStickyClone();
		}
	}

	// Debounce utility

	function debounce(fn, delay) {
		let timeout;

		return function (...args) {
			clearTimeout(timeout);
			timeout = setTimeout(() => fn.apply(this, args), delay);
		};
	}

	document.addEventListener("DOMContentLoaded", function () {
		updateStickyHeader(true);
		onScrollOrResize();

		window.addEventListener("scroll", onScrollOrResize, { passive: true });
		window.addEventListener("resize", function () {
			updateStickyHeader(true);
			onScrollOrResize();
		});

		// MutationObserver: Watch for changes to .sticky-header's parent only

		const header = getHeader();
		const targetNode = header ? header.parentNode : null;

		if (targetNode) {
			const observer = new MutationObserver(
				debounce(() => {
					updateStickyHeader(true);
					onScrollOrResize();
				}, 200),
			);

			observer.observe(targetNode, { childList: true, subtree: false });
		}
	});

	// Intersection Observer to track header visibility in viewport
	function observeHeaderVisibility(header) {
		if (intersectionObserver) {
			intersectionObserver.disconnect();
		}
		if (!header) return;

		intersectionObserver = new window.IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					headerVisible = entry.isIntersecting;
					onScrollOrResize();
				});
			},
			{
				root: null,
				threshold: 0.01, // Consider header visible if even 1% is in viewport
			}
		);
		intersectionObserver.observe(header);
	}
})();
